/**
 * 三端入口 URL 契约（业务上下文，非登录凭证）：
 *
 * 1. 空间管理后台 · 应用管理 ·「创建应用」
 *    /apps?space_id={id}&create=1
 * 2. 空间管理后台 · 顶栏 ·「开发者后台」
 *    /apps?space_id={id}
 * 3. 客户端 ·「开发者中心」
 *    /apps?space_id={id}
 *
 * 本地联调（pnpm dev）可直接打开：
 *   /apps?space_id=spc_from_admin&create=1
 *   /apps?space_id=spc_from_admin
 */

export interface EntryQuery {
  userId: string
  space_id: string
}

export interface WorkbenchEntry {
  space_id?: string
  create: boolean
}

/** 从第三方跳转 URL 中读取 user_id / space_id（兼容 camelCase） */
export function parseEntryQuery(search: string): EntryQuery | null {
  const params = new URLSearchParams(search)
  const userId = params.get('user_id') ?? params.get('userId')
  const space_id = params.get('space_id') ?? params.get('spaceId')
  if (!userId?.trim() || !space_id?.trim()) return null
  return { userId: userId.trim(), space_id: space_id.trim() }
}

/** 去掉入口参数，避免凭证长期暴露在地址栏 */
export function stripEntryQuery(search: string): string {
  const params = new URLSearchParams(search)
  ;['user_id', 'userId', 'space_id', 'spaceId'].forEach((key) => {
    params.delete(key)
  })
  const next = params.toString()
  return next ? `?${next}` : ''
}

function isCreateFlag(raw: string | null): boolean {
  if (raw === null) return false
  const v = raw.trim().toLowerCase()
  return v === '' || v === '1' || v === 'true'
}

/** 工作台业务入口：space_id + 是否自动打开创建向导 */
export function parseWorkbenchEntry(search: string): WorkbenchEntry {
  const params = new URLSearchParams(search.startsWith('?') ? search : `?${search}`)
  const spaceRaw = params.get('space_id') ?? params.get('spaceId')
  const space_id = spaceRaw?.trim() || undefined
  const create =
    params.has('create') && isCreateFlag(params.get('create'))
  return { space_id, create }
}

/** 去掉工作台入口业务参数（space_id / create），保留其他 query */
export function stripWorkbenchEntry(search: string): string {
  const params = new URLSearchParams(search.startsWith('?') ? search : `?${search}`)
  ;['space_id', 'spaceId', 'create'].forEach((key) => {
    params.delete(key)
  })
  const next = params.toString()
  return next ? `?${next}` : ''
}
